<template>
  <div class="modal-overlay" @click="$emit('clear')">
    <div class="drilldown-modal dashboard-viz" @click.stop>
      <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="$emit('clear')" />

      <header class="drilldown-header">
        <font-awesome-icon icon="magnifying-glass-chart" class="drilldown-icon" />
        <div>
          <h2>{{ title }}</h2>
          <p class="drilldown-count">{{ rows.length }} {{ rows.length === 1 ? 'result' : 'results' }}</p>
        </div>
      </header>

      <div v-if="!rows.length" class="drilldown-empty">Nothing matches this selection.</div>
      <vue-good-table
        v-else
        :columns="columns"
        :rows="rows"
        :pagination-options="{ enabled: rows.length > 8, perPage: 8 }"
        :search-options="{ enabled: false }"
        :sort-options="{ enabled: true }"
      />
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';

export default {
  name: 'DrilldownPanel',
  components: { VueGoodTable },
  props: {
    title: { type: String, required: true },
    rows: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
  },
  emits: ['clear'],
};
</script>

<style scoped>
.dashboard-viz {
  color-scheme: light;
  --surface-1:      #fcfcfb;
  --page-plane:     #f2f2ef;
  --text-primary:   #0b0b0b;
  --text-secondary: #52514e;
  --text-muted:     #898781;
  --gridline:       #e1e0d9;
  --baseline:       #c3c2b7;
  --series-1:       #2a78d6;
  --series-2:       #eb6834;
  --status-good:      #0ca30c;
  --status-warning:   #fab219;
  --status-critical:  #d03b3b;
  --border: rgba(11, 11, 11, 0.10);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(11, 11, 11, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.drilldown-modal {
  position: relative;
  background: var(--surface-1, #fff);
  border-radius: 10px;
  padding: 28px 32px 32px;
  width: min(760px, 100%);
  max-height: 88vh;
  overflow-y: auto;
  box-shadow: 0 12px 40px rgba(11, 11, 11, 0.25);
}

.window-close-icon {
  position: absolute;
  top: 16px;
  right: 18px;
  cursor: pointer;
  color: var(--text-muted, #898781);
  font-size: 18px;
}

.window-close-icon:hover {
  color: var(--text-primary, #0b0b0b);
}

.drilldown-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-right: 24px;
}

.drilldown-icon {
  color: var(--series-1);
  font-size: 20px;
  flex-shrink: 0;
}

.drilldown-header h2 {
  margin: 0 0 2px;
  font-size: 19px;
  color: var(--text-primary);
  text-align: left;
}

.drilldown-count {
  margin: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-muted);
  text-align: left;
}

.drilldown-empty {
  font-size: 13px;
  color: var(--text-muted);
  padding: 12px 0 4px;
}
</style>
